var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-table',{attrs:{"url":_vm.url,"title":"لیست تسویه ها","detailUrl":_vm.detailUrl,"fields":_vm.fields,"params":_vm.params,"tabTable":_vm.tabTable}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }